import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from 'dayjs';
import * as React from 'react';

export class InformedCell extends React.Component<GridCustomCellProps> {
  public render() {
    return (
      <td {...this.props.tdProps}>
        {this.props.dataItem.IsInformed ? dayjs.utc(this.props.dataItem.InformedDateTime).tz("America/New_York").format('MM/DD/YYYY HH:mm') : 'No'}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    if (nextProps.dataItem.Hash === this.props.dataItem.Hash) {
        return false;
    }

    return true;
  }
}
